<ng-container *ngIf="loaded_data">
  <div class="justify-content-center">
    <div class="col col-12 text-center">
      <p class="fs-3 h1 my-4">Confirmação de pagamento</p>
    </div>
    <div class="col col-12 mb-4">
      <form class="row">
        <div class="col-4 text-end">
          <label>Código de barras</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.bar_code}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Beneficiário</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.recipient}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Vencimento</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.due_date | date: 'dd/MM/yyyy'}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Pagar em</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.pay_date | date: 'dd/MM/yyyy'}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Valor</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.value}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Desconto</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.discount}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Multas</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.fine}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Juros</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.interest}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Valor total</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.total_value}}</p>
        </div>
        <div class="col-4 text-end">
          <label>Descrição</label>
        </div>
        <div class="col-12 col-md-8 text-start">
          <p class="text-muted">{{loaded_data?.description}}</p>
        </div>
      </form>
    </div>
    <!-- {{loaded_data | json}} -->
    <div class="col col-12 text-center mb-4 fw-bold">
      Deseja confirmar o pagamento no valor de {{loaded_data?.total_value}}
    </div>
    <div class="col col-12 text-center mb-4 text-primary fw-bold">
      Este pagamento terá um custo de {{cost | currency: 'BRL'}} (o valor do custo precisa estar diponível na sua
      conta). Você pode consultar o comprovante em extratos e comprovantes.
    </div>
  </div>
  <div class="btn-group my-3 mx-lg-3">
    <button type="button" class="btn btn-outline-dark w-100" loaded_data-dismiss="modal"
      (click)="modalRef.hide()">VOLTAR</button>
    <button type="button" class="btn btn-primary w-100" (click)="onConfirm()">CONFIRMAR</button>
  </div>
</ng-container>